import { useMemo } from 'react';

import { ClientCore } from 'client-core';
import { UnlockDeviceType } from 'client-web-sdk';

import useAccountState from 'src/util/clientCore/useAccountState';

export default function useUnlockDeviceType(clientCore: ClientCore): UnlockDeviceType {
  const accountState = useAccountState(clientCore);
  const unlockDeviceType = useMemo(() => {
    const securityKeyPossible = accountState.isWebauthnPossibleForSession(
      clientCore.getSessionId(),
    );
    const phonePossible = accountState.hasPushAuthenticator();
    if (securityKeyPossible && phonePossible) {
      return 'multiple';
    }
    if (securityKeyPossible) {
      return 'securityKey';
    }
    return 'phone';
  }, [accountState, clientCore]);
  return unlockDeviceType;
}
